import EditorImg from 'lowcode/components/EditorImg';
import styled from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { useReferralStore } from '../../ReferralProvider';

const EURank = () => {
    const { useLang } = useGlobal();
    const { t } = useLang('referral');
    const { pageUsing } = useReferralStore();

    return (
        <div className={styled.eu_rank}>
            <div className="container">
                <div className="eu_rank_text">
                    <div className={pageUsing === 'd3ms' ? 'd3ms_subtitle' : 'eu_rank_subtitle'}>{t('rankinglist.bottom_subtitle')}</div>
                    <div className="eu_rank_title">{t('rankinglist.bottom_title')}</div>
                    <div className="eu_rank_desc">{t('rankinglist.bottom_desc')}</div>
                </div>
                <div className="eu_rank_img">
                    {pageUsing === 'd3ms' ? (
                        <EditorImg
                            className="img"
                            pc="https://websiteoss.ecoflow.com/figma-uploads/1760613468636-k4ss1g-compressed-top_4-10_PC.png"
                            pad="https://websiteoss.ecoflow.com/figma-uploads/1760613468636-k4ss1g-compressed-top_4-10_PC.png"
                            h5="https://websiteoss.ecoflow.com/figma-uploads/1760613610016-5d1wc3-compressed-top_4-10_M.png"
                        />
                    ) : (
                        <EditorImg
                            className="img"
                            pc={'https://websiteoss.ecoflow.com/upload/image/1748526865511/top_4-10_PC.png'}
                            pad={'https://websiteoss.ecoflow.com/upload/image/1748526865511/top_4-10_PC.png'}
                            h5={'https://websiteoss.ecoflow.com/upload/image/1749027367233/top_4-10_M.png'}
                        />
                    )}
                </div>
                <div className={pageUsing === 'd3ms' ? 'd3ms_subtitle_m' : 'eu_rank_subtitle_m'} style={pageUsing === 'd3ms' ? { whiteSpace: 'pre-line' } : {}}>
                    {t('rankinglist.bottom_subtitle')}
                </div>
            </div>
        </div>
    );
};

export default EURank;
